import {
  ContractorInterface,
  ContractorResourceTypeEnum,
  PhaseTypeEnum,
} from '@vatos-pas/common';
import { phaseTypeToResourceType } from './phaseTypeToResourceType';

const AVAILABILITY_FIELD: Record<
  ContractorResourceTypeEnum,
  keyof ContractorInterface
> = {
  [ContractorResourceTypeEnum.Hanger]: 'hangerAvailable',
  [ContractorResourceTypeEnum.Finisher]: 'finisherAvailable',
  [ContractorResourceTypeEnum.Sprayer]: 'sprayerAvailable',
  [ContractorResourceTypeEnum.Bumper]: 'bumperAvailable',
  [ContractorResourceTypeEnum.Paint]: 'paintAvailable',
  [ContractorResourceTypeEnum.Trim]: 'trimAvailable',
};

const HIGH_CEILING_PHASES: PhaseTypeEnum[] = [
  PhaseTypeEnum.Hanging,
  PhaseTypeEnum.Hang,
  PhaseTypeEnum.Finishing,
  PhaseTypeEnum.Finish,
];

export const contractorFilterForPhase = (
  phaseType: PhaseTypeEnum,
  regionId: string,
  job: { highCeiling: boolean },
): Record<string, string | boolean> => {
  const filter: Record<string, string | boolean> = {
    active: true,
    suspended: false,
    archived: false,
    'contractorRegions.regionId': regionId,
  };

  const resourceType = phaseTypeToResourceType(phaseType);
  if (resourceType) {
    filter[AVAILABILITY_FIELD[resourceType]] = true;
  }

  if (job.highCeiling && HIGH_CEILING_PHASES.includes(phaseType)) {
    filter.canPerformHighCeilingTasks = true;
  }

  return filter;
};
